import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT } from '../../../styles/constants';

const safeArea = {
  top: 'env(safe-area-inset-top, 0px)',
  bottom: 'env(safe-area-inset-bottom, 0px)',
} as const;
const layoutBottomGap = 'var(--vv-layout-bottom-gap, 0px)';
const bottomInset = `calc(${safeArea.bottom} + var(--vv-layout-bottom-gap, 0px))`;

export const useStyles = makeStyles<Theme>()((theme) => ({
  confirmDialogWrapper: {
    maxWidth: 600,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    [theme.breakpoints.down('md')]: {
      maxHeight: MAX_PAGE_HEIGHT,
      overflowY: 'auto',
    },
  },
  confirmDialogHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    fontWeight: 700,
    fontSize: 20,
    lineHeight: '28px',
    color: theme.palette.text.primary,

    '& svg': {
      marginRight: 5,
    },

    '& button': {
      minWidth: 0,
    },
  },

  confirmDialogTitle: {
    display: 'flex',
    alignItems: 'center',
    ...theme.mixins.appEllipsis,
  },
  confirmDialogContent: {
    padding: 16,
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '24px',
    color: theme.palette.text.primary,

    '& p': {
      margin: 0,
    },

    '& p + p': {
      marginTop: 8,
    },
  },
  confirmDialogFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: '8px 16px 16px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
      alignItems: 'stretch',
      '& > *': {
        width: '100%',
      },
    },
  },
}));
